import store from "@/store";

export default [
    {
        path: "/mkt",
        name: "mkt__root__",
        redirect: {
            name: "mkt-index",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            next();
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "mkt",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "mkt-index",
                component: () => import("@/views/mkt/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/mkt/customer",
        name: "mkt-customer",
        meta: {
            title: "客户管理",
            icon: "mkt-enterprise",
            parent: "mkt",
            permission: "manage_customer",
        },
        // hidden: true,
        component: () => import("@/layouts/default.vue"),
        redirect: "/mkt/customer/organization",
        children: [
            {
                path: "organization",
                name: "mkt-enterprise-organization",
                component: () => import("@/views/omp/enterprise/organization.vue"),
                props: { mode: "normal" },
                meta: {
                    title: "企业管理",
                    icon: "mkt-organization",
                },
            },
            {
                path: "dashboard",
                name: "mkt-enterprise-dashboard",
                component: () => import("@/views/omp/enterprise/dashboard.vue"),
                meta: {
                    title: "园区管理",
                    icon: "mkt-dashboard",
                },
            },
            {
                path: "user",
                name: "mkt-account-user",
                component: () => import("@/views/omp/account/user.vue"),
                meta: {
                    title: "账号管理",
                    icon: "mkt-account-user",
                },
            },
            {
                path: "other",
                name: "mkt-account-other",
                component: () => import("@/views/omp/account/other-user.vue"),
                meta: {
                    title: "散户管理",
                    icon: "mkt-account-other",
                },
            },
            {
                path: "address",
                name: "mkt-customer-address",
                component: () => import("@/views/fms/customer/address.vue"),
                meta: {
                    title: "地址管理",
                    icon: "mkt-address",
                },
            },
        ],
    },
    {
        path: "/mkt/order",
        name: "mkt-order",
        meta: {
            title: "签单系统",
            icon: "mkt-order",
            parent: "mkt",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/mkt/order/intention",
        children: [
            {
                path: "manager",
                name: "mkt-order-manager",
                component: () => import("@/views/omp/enterprise/organization.vue"),
                props: { mode: "manager" },
                meta: {
                    title: "负责经理",
                    icon: "mkt-manager",
                    key: "manager",
                    affix: false,
                    permission: "manage_order_setting",
                },
            },
            {
                path: "project",
                name: "mkt-order-project",
                component: () => import("@/views/fms/order/project.vue"),
                meta: {
                    title: "项目管理",
                    icon: "mkt-order-project",
                    affix: false,
                    permission: "manage_order_setting",
                },
            },
            {
                path: "project-detail/:id(\\d+)?",
                name: "mkt-order-project-detail",
                component: () => import("@/views/fms/order/project-detail.vue"),
                hidden: true,
                meta: {
                    title: "项目详情",
                    affix: false,
                    activeMenu: "/mkt/order/project",
                },
            },
            {
                path: "intention",
                name: "mkt-order-intention",
                component: () => import("@/views/fms/order/intention"),
                meta: {
                    title: "意向订单",
                    icon: "mkt-order-intention",
                    affix: false,
                    keepAlive: true,
                    permission: "manage_order",
                },
            },
            {
                path: "intention_edit/:id(\\d+)?",
                name: "mkt-order-intention-edit",
                hidden: true,
                component: () => import("@/views/fms/order/components/intention-edit.vue"),
                meta: {
                    title: "订单编辑",
                    affix: false,
                    activeMenu: "/mkt/order/intention",
                    permission: "manage_order",
                },
            },
            {
                path: "intention_detail/:id(\\d+)?",
                name: "mkt-order-intention-detail",
                hidden: true,
                component: () => import("@/views/fms/order/components/intention-detail.vue"),
                meta: {
                    title: "订单详情",
                    affix: false,
                    activeMenu: "/mkt/order/intention",
                    permission: "manage_order",
                },
            },
            {
                path: "intention/backfill",
                name: "mkt-order-intention-backfill",
                hidden: true,
                component: () => import("@/views/fms/order/components/intention-backfill-form.vue"),
                meta: {
                    title: "补录订单",
                },
            },
            {
                path: "intention_sign/:id(\\d+)?",
                name: "mkt-order-intention-sign",
                hidden: true,
                component: () => import("@/views/fms/order/components/intention-sign.vue"),
                meta: {
                    title: "开始签约",
                    affix: false,
                    activeMenu: "/mkt/order/intention",
                    permission: "manage_order",
                },
            },
            {
                path: "sign",
                name: "mkt-order-sign",
                component: () => import("@/views/fms/order/sign"),
                meta: {
                    title: "签约订单",
                    icon: "mkt-order-sign",
                    affix: false,
                    key: "sign",
                    // 这里不要加keep-alive
                    permission: "manage_order_sold",
                },
            },
            {
                path: "acceptance",
                name: "mkt-acceptance",
                component: () => import("@/views/fms/acceptance/acceptance.vue"),
                props: { moduleType: "sign" },
                meta: {
                    title: "验收管理",
                    icon: "mkt-acceptance",
                    affix: false,
                    key: "sign",
                    keepAlive: true,
                    permission: "manage_order_sold",
                },
            },
            {
                path: "acceptance/hand",
                name: "acceptance-hand",
                component: () => import("@/views/fms/acceptance/acceptance-hand.vue"),
                props: true,
                meta: {
                    title: "验收补录",
                },
                hidden: true,
            },
            {
                path: "acceptance/edit",
                name: "acceptance-edit",
                component: () => import("@/views/fms/acceptance/acceptance-form.vue"),
                props: true,
                meta: {
                    title: "编辑验收",
                },
                hidden: true,
            },
            {
                path: "acceptance/form",
                name: "sign-acceptance-form",
                component: () => import("@/views/fms/acceptance/acceptance-form.vue"),
                props: true,
                meta: {
                    title: "发起验收",
                    activeMenu: "/mkt/order/acceptance",
                },
                hidden: true,
            },
            {
                path: "acceptance/detail/:id(\\d+)?",
                name: "acceptance-detail",
                component: () => import("@/views/fms/acceptance/acceptance-detail.vue"),
                props: true,
                meta: {
                    title: "验收详情",
                    activeMenu: "/mkt/order/acceptance",
                },
                hidden: true,
            },
            {
                path: "acceptance/edit/detail",
                name: "acceptance-edit-detail",
                component: () => import("@/views/fms/acceptance/acceptance-detail.vue"),
                props: true,
                meta: {
                    title: "补录验收",
                },
                hidden: true,
            },
            {
                path: "sign_create",
                name: "mkt-entry-sign-add",
                component: () => import("@/views/fms/order/components/entry-order.vue"),
                meta: {
                    title: "录入订单",
                    activeMenu: "/mkt/order/sign",
                    permission: "manage_order",
                },
                hidden: true,
            },
            {
                path: "sign_edit/:id(\\d+)",
                name: "mkt-entry-sign-edit",
                component: () => import("@/views/fms/order/components/entry-order.vue"),
                meta: {
                    title: "编辑订单",
                    activeMenu: "/mkt/order/sign",
                    permission: "manage_order",
                },
                hidden: true,
            },
            {
                path: "sign_detail/:id(\\d+)?",
                name: "mkt-order-sign-detail",
                hidden: true,
                component: () => import("@/views/fms/order/components/sign-detail.vue"),
                meta: {
                    title: "签约详情",
                    affix: false,
                    activeMenu: "/mkt/order/sign",
                    permission: "manage_order",
                },
            },
            {
                path: "start_produce/:order_id(\\d+)",
                name: "mkt-order-start-produce",
                component: () => import("@/views/fms/order/components/start-produce.vue"),
                meta: {
                    title: "开始生产",
                },
                hidden: true,
            },
            {
                path: "deliver_detail/:order_id(\\d+)",
                name: "mkt-order-deliver-detail",
                component: () => import("@/views/fms/order/components/order-deliver-detail.vue"),
                meta: {
                    title: "发货",
                    keepAlive: true,
                    affix: false,
                },
                hidden: true,
            },
            {
                path: "install/check_info/:order_id(\\d+)/:install_id(\\d+)?",
                name: "mkt-order-install-check-info",
                component: () => import("@/views/fms/order/components/install/check-info.vue"),
                meta: {
                    title: "信息确认",
                    activeMenu: "/mkt/order/sign",
                },
                hidden: true,
            },
            {
                path: "install/prepare_node/:order_id(\\d+)/:check_id(\\d+)/:install_id(\\d+)?",
                name: "mkt-order-install-prepare-node",
                component: () => import("@/views/fms/order/components/install/prepare-node.vue"),
                meta: {
                    title: "配置节点",
                    activeMenu: "/mkt/order/sign",
                },
                hidden: true,
            },
            {
                path: "install/appointment/:order_id(\\d+)/:check_id(\\d+)/:install_id(\\d+)?",
                name: "mkt-order-install-appointment",
                component: () => import("@/views/fms/order/components/install/appointment.vue"),
                meta: {
                    title: "预约安装",
                    activeMenu: "/mkt/order/sign",
                },
                hidden: true,
            },
            {
                path: "start_debug/:order_id(\\d+)",
                name: "mkt-order-start-debug",
                component: () => import("@/views/fms/order/components/start-debug.vue"),
                meta: {
                    title: "开始调试",
                },
                hidden: true,
            },
            {
                path: "acceptance_form/:order_id(\\d+)",
                name: "acceptance-form",
                component: () => import("@/views/fms/order/components/acceptance-form.vue"),
                meta: {
                    title: "生成验收单",
                    activeMenu: "/mkt/order/sign",
                },
                hidden: true,
            },
        ],
    },
    {
        path: "/mkt/oem",
        name: "mkt-oem",
        meta: {
            title: "OEM订单",
            icon: "mkt-oem",
            parent: "mkt",
            affix: false,
            permission: "manage_oem",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/mkt/oem/list",
        children: [
            {
                path: "oem-card",
                name: "mkt-bill-oem-card",
                component: () => import("@/views/fms/bill/oem-card.vue"),
                meta: {
                    title: "收款卡号",
                    icon: "mkt-oem-card",
                    affix: false,
                },
            },
            {
                path: "oem-card-log",
                name: "mkt-bill-oem-card-log",
                component: () => import("@/views/fms/bill/oem-card-log.vue"),
                meta: {
                    title: "收款日志",
                    icon: "mkt-oem-card-log",
                    affix: false,
                },
            },
            {
                path: "list",
                name: "mkt-oem-list",
                component: () => import("@/views/fms/order/oem"),
                meta: {
                    title: "OEM订单",
                    icon: "mkt-oem",
                    affix: false,
                },
            },
            {
                path: "detail/:id",
                name: "mkt-oem-detail",
                hidden: true,
                component: () => import("@/views/fms/order/components/oem-detail.vue"),
                meta: {
                    title: "订单详情",
                    affix: false,
                    activeMenu: "/mkt/oem/list",
                },
            },
            {
                path: "inventory",
                name: "mkt-oem-inventory",
                component: () => import("@/views/fms/produce/oem_inventory/index.vue"),
                meta: {
                    title: "客户库存",
                    icon: "mkt-oem-inventory",
                    parent: "mkt",
                },
            },
        ],
    },
    {
        path: "/mkt/mall",
        name: "mkt-mall",
        meta: {
            title: "内购商城",
            icon: "mkt-mall",
            parent: "mkt",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/mkt/mall/internal",
        children: [
            {
                path: "quote",
                name: "mkt-mall-quote",
                component: () => import("@/views/fms/mall/quote/quote_hall.vue"),
                meta: {
                    title: "产品报价",
                    icon: "mkt-quote-hall",
                    affix: false,
                    permission: "mall_internal",
                },
            },
            {
                path: "quote/cart",
                name: "mkt-mall-quote-cart",
                hidden: true,
                component: () => import("@/views/fms/mall/quote/shop_cart.vue"),
                meta: {
                    title: "购物车",
                    affix: false,
                    activeMenu: "/mkt/mall/quote",
                },
            },

            {
                path: "goods_price_detail/:id(\\d+)?",
                name: "mkt-mall-goods-price-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/goods_price_detail.vue"),
                meta: {
                    title: "定价详情",
                    affix: false,
                    activeMenu: "/mkt/mall/goods_price",
                    permission: "manage_product_price",
                },
            },
            {
                path: "internal",
                name: "mkt-mall-goods",
                component: () => import("@/views/fms/mall/internal.vue"),
                meta: {
                    title: "内购下单",
                    icon: "mkt-internal",
                    affix: false,
                    permission: "mall_internal",
                },
            },

            {
                path: "cart",
                name: "mkt-mall-cart",
                hidden: true,
                component: () => import("@/views/fms/mall/shop_cart.vue"),
                meta: {
                    title: "购物车",
                    affix: false,
                    activeMenu: "/mkt/mall/internal",
                },
            },
            {
                path: "order/:id(\\d+)",
                name: "mkt-mall-order-pay",
                hidden: true,
                component: () => import("@/views/fms/mall/internal_order.vue"),
                meta: {
                    title: "订单",
                    affix: false,
                    activeMenu: "/mkt/mall/internal",
                },
            },
            {
                path: "order",
                name: "mkt-mall-order",
                component: () => import("@/views/fms/mall/order.vue"),
                meta: {
                    title: "订单管理",
                    icon: "mkt-mall-order",
                    affix: false,
                    permission: "mall_internal",
                },
            },
            {
                path: "order/detail/:id(\\d+)?",
                name: "mkt-mall-order-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/order_detail.vue"),
                meta: {
                    title: "订单详情",
                    affix: false,
                    activeMenu: "/mkt/mall/order",
                },
            },
            {
                path: "quote-manage",
                name: "mkt-mall-quote-manage",
                component: () => import("@/views/fms/mall/quote/quote_management.vue"),
                meta: {
                    title: "报价管理",
                    icon: "mkt-quote",
                    affix: false,
                    permission: "mall_internal",
                },
            },
            {
                path: "quote/detail/:id(\\d+)",
                name: "mkt-mall-quote-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/quote/quote_detail.vue"),
                meta: {
                    title: "报价详情",
                    affix: false,
                    activeMenu: "/mkt/mall/quote-manage",
                },
            },
        ],
    },
    {
        path: "/mkt/consult",
        name: "mkt-consult",
        meta: {
            title: "咨询管理",
            icon: "mkt-consult",
            parent: "mkt",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/mkt/consult/contact",
        children: [
            {
                path: "contact",
                name: "mkt-contact",
                component: () => import("@/views/cms/service/contact"),
                meta: {
                    title: "联系咨询",
                    icon: "mkt-contact",
                    affix: false,
                    permission: "manage_order_sold",
                },
            },
            {
                path: "quotation",
                name: "mkt-quotation",
                component: () => import("@/views/cms/service/quotation"),
                meta: {
                    title: "报价咨询",
                    icon: "mkt-quotation",
                    affix: false,
                    permission: "manage_order_sold",
                },
            },
        ],
    },
    {
        path: "/mkt/after-sales",
        name: "mkt-after-sales",
        meta: {
            title: "售后中心",
            icon: "mkt-after-sales",
            parent: "mkt",
            permission: "manage_after_sale",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/mkt/after-sales/workflows",
        children: [
            {
                path: "workflows",
                name: "mkt-workflows",
                component: () => import("@/views/fms/after-sales/workflows.vue"),
                meta: {
                    title: "售后工单",
                    icon: "mkt-after-sales-workflows",
                    affix: false,
                },
            },

            {
                path: "create",
                name: "mkt-create-workflow",
                component: () => import("@/views/fms/after-sales/components/workflow-form.vue"),
                meta: {
                    title: "创建工单",
                    activeMenu: "/mkt/after-sales/workflows",
                },
                hidden: true,
            },
            {
                path: "edit/:id(\\d+)",
                name: "mkt-edit-workflow",
                component: () => import("@/views/fms/after-sales/components/workflow-form.vue"),
                meta: {
                    title: "编辑工单",
                    activeMenu: "/mkt/after-sales/workflows",
                },
                hidden: true,
            },
            {
                path: "detail/:id(\\d+)",
                name: "mkt-workflow-detail",
                component: () => import("@/views/fms/after-sales/components/workflow-detail.vue"),
                meta: {
                    title: "工单详情",
                    activeMenu: "/mkt/after-sales/workflows",
                },
                hidden: true,
            },
            {
                path: "charge-payment/:bucket_id(\\d+)/:id(\\d+)",
                name: "mkt-charge-payment",
                component: () => import("@/views/fms/after-sales/components/charge-payment.vue"),
                meta: {
                    title: "维修清单付款",
                    activeMenu: "/mkt/after-sales/workflows",
                },
                hidden: true,
            },
            {
                path: "analysis",
                name: "mkt-after-sales-analysis",
                component: () => import("@/views/fms/after-sales/workflows-stat.vue"),
                meta: {
                    title: "统计分析",
                    icon: "all-stat",
                    affix: false,
                },
            },
            {
                path: "types",
                name: "mkt-after-sales-types",
                component: () => import("@/views/fms/after-sales/types.vue"),
                meta: {
                    title: "类型配置",
                    icon: "all-setting",
                    affix: false,
                    permission: "fms_manage_after_sales",
                },
            },
            {
                path: "template",
                name: "mkt-after-sales-template",
                component: () => import("@/views/fms/after-sales/workflows-template.vue"),
                meta: {
                    title: "处理模板",
                    icon: "mkt-after-sales-template",
                    affix: false,
                    key: "after_sales",
                },
            },
            {
                path: "ewx-phone",
                name: "mkt-enterprise-wechat-phone",
                component: () => import("@/views/fms/after-sales/ewx-phone.vue"),
                meta: {
                    title: "企微电话",
                    icon: "mkt-wechat-phone",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/mkt/install",
        name: "mkt-install",
        meta: {
            title: "安装中心",
            icon: "mkt-maintenance",
            parent: "mkt",
            permission: "manage_install",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/mkt/repair/install",
        children: [
            {
                path: "install",
                name: "prod-repair-install",
                component: () => import("@/views/fms/repair/install-workflows.vue"),
                meta: {
                    title: "安装工单",
                    icon: "mkt-install-workflows",
                    affix: false,
                },
            },
            {
                path: "acceptance",
                name: "mkt-install-acceptance",
                component: () => import("@/views/fms/acceptance/acceptance.vue"),
                props: { moduleType: "install" },
                meta: {
                    title: "验收管理",
                    icon: "mkt-acceptance",
                    affix: false,
                    key: "install",
                    keepAlive: true,
                },
            },
            {
                path: "acceptance/form",
                name: "install-acceptance-form",
                component: () => import("@/views/fms/acceptance/acceptance-form.vue"),
                props: true,
                meta: {
                    title: "发起验收",
                },
                hidden: true,
            },
            // {
            //     path: "acceptance/detail",
            //     name: "acceptance-detail",
            //     component: () => import("@/views/fms/acceptance/acceptance-detail.vue"),
            //     props: true,
            //     meta: {
            //         title: "验收详情",
            //         activeMenu: "/mkt/install/acceptance",
            //     },
            //     hidden: true,
            // },
            {
                path: "install-detail/:id(\\d+)",
                name: "prod-repair-install-detail",
                component: () => import("@/views/fms/repair/components/install-detail.vue"),
                meta: {
                    title: "安装工单详情",
                    activeMenu: "/prod/repair/install",
                },
                hidden: true,
            },
            {
                path: "install-add",
                name: "prod-repair-install-add",
                component: () => import("@/views/fms/repair/components/install-edit.vue"),
                meta: {
                    title: "创建安装工单",
                    activeMenu: "/prod/repair/install",
                },
                hidden: true,
            },
            {
                path: "install-edit/:id(\\d+)",
                name: "prod-repair-install-edit",
                component: () => import("@/views/fms/repair/components/install-edit.vue"),
                meta: {
                    title: "编辑安装工单",
                    activeMenu: "/prod/repair/install",
                },
                hidden: true,
            },
        ],
    },
    {
        path: "/mkt/repair",
        name: "mkt-repair",
        meta: {
            title: "维修中心",
            parent: "mkt",
            permission: "manage_repair",
        },
        hidden: true,
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/mkt/repair/install",
        children: [
            {
                path: "task",
                name: "prod-repair-task",
                component: () => import("@/views/fms/repair/workflows.vue"),
                meta: {
                    title: "维修工单",
                    affix: false,
                },
            },
            {
                path: "acceptance",
                name: "prod-repair-acceptance",
                component: () => import("@/views/fms/acceptance/acceptance.vue"),
                props: { moduleType: "repair" }, // 修改为维修类型
                meta: {
                    title: "验收管理",
                    affix: false,
                    key: "repair",
                    keepAlive: true,
                },
            },
            {
                path: "acceptance/form",
                name: "repair-acceptance-form",
                component: () => import("@/views/fms/acceptance/acceptance-form.vue"),
                props: true,
                meta: {
                    title: "发起验收",
                },
                hidden: true,
            },

            {
                path: "create",
                name: "prod-repair-task-create",
                component: () => import("@/views/fms/repair/components/workflow-form.vue"),
                meta: {
                    title: "创建维修任务",
                    activeMenu: "/prod/repair/task",
                },
                hidden: true,
            },
            {
                path: "edit/:id(\\d+)",
                name: "prod-repair-task-edit",
                component: () => import("@/views/fms/repair/components/workflow-form.vue"),
                meta: {
                    title: "编辑维修任务",
                    activeMenu: "/prod/repair/task",
                },
                hidden: true,
            },
            {
                path: "detail/:id(\\d+)",
                name: "prod-repair-task-detail",
                component: () => import("@/views/fms/repair/components/workflow-detail.vue"),
                meta: {
                    title: "维修任务详情",
                    activeMenu: "/prod/repair/task",
                },
                hidden: true,
            },
            {
                path: "analysis",
                name: "prod-repair-analysis",
                component: () => import("@/views/fms/repair/workflows-stat.vue"),
                meta: {
                    title: "统计分析",
                    affix: false,
                },
            },
            {
                path: "types",
                name: "prod-repair-types",
                component: () => import("@/views/fms/repair/types.vue"),
                meta: {
                    title: "类型配置",
                    affix: false,
                },
            },
            {
                path: "template",
                name: "prod-repair-template",
                component: () => import("@/views/fms/repair/workflows-template.vue"),
                meta: {
                    title: "处理模板",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/mkt/system",
        name: "mkt-system",
        meta: {
            title: "系统管理",
            icon: "all-system",
            parent: "mkt",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/mkt/system/template",
        children: [
            {
                path: "template",
                name: "mkt-order-promise-template",
                component: () => import("@/views/fms/order/promise-template.vue"),
                meta: {
                    title: "文案模版",
                    icon: "mkt-template",
                    affix: false,
                    permission: "manage_order_setting",
                },
            },
        ],
    },
];
